export default __webpack_public_path__ + "static/main-content-management-system-8abb075b91c2ccfe137838dcb9a45edb.png";